module.exports = __webpack_public_path__ + "img/bg_02.7968b377.png";